var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmericanExp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 30,
    viewBox: "0 0 54 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6188_23103)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H57.75V17.5256L54.8915 21.4855L57.75 25.0099V30H0V15.0309L1.78654 13.2093L0 11.467V0Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4785 25.7344V17.5776H19.4508L20.4134 18.7856L21.4078 17.5776H53.9749V25.1718C53.9749 25.1718 53.1232 25.7262 52.1382 25.7344H34.1051L33.0198 24.4486V25.7344H29.4633V23.5395C29.4633 23.5395 28.9775 23.8459 27.9271 23.8459H26.7166V25.7344H21.3317L20.3705 24.5005L19.3945 25.7344H10.4785Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.4301L2.02328 6.88965H5.52232L6.67055 9.43302V6.88965H11.0202L11.7037 8.72792L12.3664 6.88965H31.8917V7.81381C31.8917 7.81381 32.9182 6.88965 34.605 6.88965L40.9403 6.91096L42.0687 9.42104V6.88965H45.7087L46.7106 8.33149V6.88965H50.3839V15.0464H46.7106L45.7505 13.5999V15.0464H40.4025L39.8647 13.7606H38.427L37.8979 15.0464H34.2711C32.8196 15.0464 31.8917 14.1411 31.8917 14.1411V15.0464H26.4234L25.3381 13.7606V15.0464H5.00396L4.46651 13.7606H3.03338L2.49974 15.0464H0V11.4301Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.73872 7.89502L0.00976562 14.0025H1.78646L2.28998 12.7795H5.21722L5.71814 14.0025H7.53396L4.80762 7.89502H2.73872ZM3.74838 9.31642L4.64064 11.4536H2.85352L3.74838 9.31642Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72266 14.0016V7.89404L10.2474 7.90307L11.7159 11.8408L13.1493 7.89404H15.6538V14.0016H14.0676V9.50128L12.3862 14.0016H10.995L9.30889 9.50128V14.0016H7.72266Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7383 14.0016V7.89404H21.9144V9.2602H18.3412V10.3049H21.8309V11.5907H18.3412V12.6756H21.9144V14.0016H16.7383Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.834 7.89502V14.0025H24.4202V11.8328H25.0881L26.99 14.0025H28.9285L26.8413 11.7524C27.6979 11.6828 28.5815 10.9751 28.5815 9.87645C28.5815 8.59122 27.5335 7.89502 26.3639 7.89502H22.834ZM24.4202 9.26117H26.2334C26.6684 9.26117 26.9848 9.58868 26.9848 9.90407C26.9848 10.3098 26.5749 10.547 26.2569 10.547H24.4202V9.26117Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.8481 14.0016H29.2285V7.89404H30.8481V14.0016Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6892 14.0016H34.3396C32.6481 14.0016 31.6211 12.7188 31.6211 10.9729C31.6211 9.18391 32.6366 7.89404 34.7727 7.89404H36.5259V9.34056H34.7086C33.8415 9.34056 33.2282 9.99195 33.2282 10.988C33.2282 12.1708 33.9294 12.6675 34.9397 12.6675H35.3571L34.6892 14.0016Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.1411 7.89502L35.4121 14.0025H37.1888L37.6923 12.7795H40.6196L41.1205 14.0025H42.9363L40.21 7.89502H38.1411ZM39.1507 9.31642L40.043 11.4536H38.2559L39.1507 9.31642Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.1211 14.0016V7.89404H45.1378L47.7128 11.7313V7.89404H49.2991V14.0016H47.3476L44.7073 10.0638V14.0016H43.1211Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5625 24.6895V18.582H16.7386V19.9482H13.1654V20.9929H16.6552V22.2787H13.1654V23.3636H16.7386V24.6895H11.5625Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.9258 24.6895V18.582H42.1019V19.9482H38.5287V20.9929H42.0017V22.2787H38.5287V23.3636H42.1019V24.6895H36.9258Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9389 24.6895L19.4592 21.6735L16.8789 18.582H18.8774L20.414 20.4931L21.9559 18.582H23.8761L21.3298 21.6358L23.8546 24.6895H21.8565L20.3645 22.8086L18.9087 24.6895H16.9389Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0449 18.583V24.6905H25.6729V22.7618H27.3426C28.7555 22.7618 29.8263 22.0403 29.8263 20.6373C29.8263 19.4749 28.9864 18.583 27.5487 18.583H24.0449ZM25.6729 19.9642H27.4313C27.8878 19.9642 28.214 20.2335 28.214 20.6674C28.214 21.075 27.8894 21.3706 27.4261 21.3706H25.6729V19.9642Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.5137 18.582V24.6895H32.0999V22.5198H32.7678L34.6697 24.6895H36.6082L34.521 22.4394C35.3776 22.3698 36.2612 21.6622 36.2612 20.5635C36.2612 19.2782 35.2132 18.582 34.0436 18.582H30.5137ZM32.0999 19.9482H33.9131C34.3481 19.9482 34.6645 20.2757 34.6645 20.5911C34.6645 20.9968 34.2545 21.234 33.9366 21.234H32.0999V19.9482Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8362 24.6895V23.3636H46.0107C46.4805 23.3636 46.6838 23.1192 46.6838 22.8513C46.6838 22.5945 46.4811 22.3349 46.0107 22.3349H44.5762C43.3292 22.3349 42.6348 21.6036 42.6348 20.5057C42.6348 19.5264 43.2707 18.582 45.1237 18.582H48.2127L47.5448 19.9562H44.8732C44.3626 19.9562 44.2054 20.2142 44.2054 20.4605C44.2054 20.7137 44.3996 20.9929 44.7898 20.9929H46.2925C47.6826 20.9929 48.2857 21.7519 48.2857 22.7458C48.2857 23.8143 47.6136 24.6895 46.2168 24.6895H42.8362Z",
    fill: "#016FD0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6584 24.6895V23.3636H51.833C52.3027 23.3636 52.5061 23.1192 52.5061 22.8513C52.5061 22.5945 52.3034 22.3349 51.833 22.3349H50.3985C49.1515 22.3349 48.457 21.6036 48.457 20.5057C48.457 19.5264 49.093 18.582 50.946 18.582H54.035L53.3671 19.9562H50.6955C50.1848 19.9562 50.0276 20.2142 50.0276 20.4605C50.0276 20.7137 50.2219 20.9929 50.612 20.9929H52.1148C53.5048 20.9929 54.108 21.7519 54.108 22.7458C54.108 23.8143 53.4359 24.6895 52.0391 24.6895H48.6584Z",
    fill: "#016FD0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6188_23103"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 30,
    rx: 5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmericanExp);
export default __webpack_public_path__ + "static/media/AmericanExp.cd62e4bb716ef3eb040733c538b8b370.svg";
export { ForwardRef as ReactComponent };